// src/index.ts
function isAdminRole(role) {
  return String(role) === "Admin";
}
function safeReturnTo(value) {
  if (!value) return null;
  if (value.startsWith("http://") || value.startsWith("https://")) return null;
  if (!value.startsWith("/")) return null;
  return value;
}
export {
  isAdminRole,
  safeReturnTo
};
